import { CarrierType } from "@gtpl/shared-models/common-models";
import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
@Entity("rm_re_weighing")
export class RMReWeighingEntity {
    @PrimaryGeneratedColumn("increment", { name: 'rm_re_weighing_id' })
    rmReWeighingId: number;

    @Column({
        type: 'enum',
        nullable: false,
        enum: CarrierType,
        name: "carrier_type"
    })
    carrierType: CarrierType;


    @Column("varchar", {
        nullable: true,
        name: "expected_cnt_qty",
        length: 50
    })
    expectedCntQty: string | null;

    @Column({
        type: 'decimal',
        nullable: true,
        default: 0,
        name: 'count',
        precision:10,scale:2
    })
    count: number;

    @Column({
        type: 'int',
        nullable: true,
        default: 0,
        name: 'no_of_crates_or_nets'
    })
    noOfCratesOrNets: number;

    @Column({
        type: 'decimal',
        nullable: true,
        default: 0,
        name: 'quantity',
        precision:10,scale:3
    })
    quantity: number;

    @Column({
        type: 'int',
        nullable: true,
        default: 0,
        name: 'plant_id'
    })
    plantId: number;

    @Column("int", {
        nullable: null,
        name: "grn_id",
    })
    grnId: number;

    @Column("int", {
        nullable: null,
        name: "grn_item_id",
    })
    grnItemId: number;

    @Column("int", {
        nullable: null,
        name: "indent_id",
    })
    indentId: number;

    @Column("int", {
        nullable: true,
        name: "indent_item_id",
    })
    indentItemId: number;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;

    @CreateDateColumn({ name: "created_at" })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        length: 40,
        default: 'Admin',
        name: "created_user"
    })
    createdUser: string | null;

    @UpdateDateColumn({ name: "updated_at" })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;
}

